<div class="row g-3 mt-4 mx-3 text-start">
  <div class="col-6">
    <label class="form-label mb-0">Fecha de asignación</label>
    <div class="position-relative">
      <!-- ========== input oculto ============ -->
      <input type="text" matInput [matDatepicker]="picker" [(ngModel)]="fechaAsignacion" class="d-none">
      <!-- ========== input visible ============ -->
      <input type="text" [value]="fechaAsignacion | formatoFecha" class="form-control" readonly (click)="picker.open()">
      <mat-icon fontIcon="calendar_month" class="position-absolute top-50 translate-middle-y end-0 me-3" style="cursor: pointer;" (click)="picker.open()"></mat-icon>
      <mat-datepicker touchUi #picker></mat-datepicker>
    </div>
  </div>

  <div class="col-6">
    <label class="mb-0">Selecciona el horario</label>
    <ng-select [(ngModel)]="horarioSeleccionado" [items]="horarios" bindLabel="nombreHorario" notFoundText="Horario no encontrado" placeholder="Selecciona el horario" appendTo="body" dropdownPosition="auto"> </ng-select>
  </div>

  <div class="col-6">
    <label class="mb-0 text-start">Incluir empleados</label>
    <ng-select
      [items]="empleados"
      [(ngModel)]="empleadosSeleccionados"
      bindLabel="nombreCompleto"
      [multiple]="true"
      [virtualScroll]="true"
      [closeOnSelect]="false"
      (ngModelChange)="incluirEmpleados(empleadosSeleccionados)"
      notFoundText="Empleado no encontrado"
      placeholder="Seleccionar empleados"
      appendTo="body"
      dropdownPosition="auto">
      <ng-template ng-option-tmp let-item="item">
        {{ nombreCompleto(item) }}
      </ng-template>
    </ng-select>
  </div>

  <div class="col-6 d-flex justify-content-end align-items-center gap-1">
    <button mat-raised-button class="text-danger" (click)="exportarPDF()" matTooltip="Exportar a PDF">
        <mat-icon>picture_as_pdf</mat-icon>
    </button>
    <button mat-raised-button type="button" class="btn mx-2" matTooltip="Exportar a Excel" (click)="exportarExcel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="100" viewBox="0 0 48 48">
        <g fill="none" stroke="#026917" stroke-linecap="round" stroke-width="4"><path stroke-linejoin="round" d="M8 15V6a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-9"/><path d="M31 15h3m-6 8h6m-6 8h6"/><path stroke-linejoin="round" d="M4 15h18v18H4zm6 6l6 6m0-6l-6 6"/></g>
      </svg>
    </button>
    <button [disabled]="cargando" mat-raised-button class="text-success d-flex" (click)="aplicarCambios()">
      <mat-icon fontIcon="save" class="me-0"></mat-icon>
      <h4 class="mb-0 ms-2">Asignar horarios</h4>
    </button>
  </div>
</div>

<div class="row px-5 py-2 col-12 text-white bg-primary" *ngIf="mensajeError">
  <mat-icon>warning</mat-icon>
  <h5>
    <b>{{ mensajeError }}</b>
  </h5>
</div>

<div class="row px-5 py-2 col-12 text-white bg-success" *ngIf="mensajeRespuesta">
  <mat-icon>done</mat-icon>
  <h5>
    <b>{{ mensajeRespuesta }}</b>
  </h5>
</div>

<div *ngIf="cargando">
  <div class="text-center py-5">
    <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>Cargando datos...</span>
  </div>
</div>

<div class="mat-elevation-z8 mx-3 mt-3 overflow-auto" *ngIf="!cargando">
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          color="primary"
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          color="primary"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="clave">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let empleado">{{ empleado.numero }}</td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef>Nombre empleado</th>
      <td mat-cell *matCellDef="let empleado">{{ nombreCompleto(empleado) }}</td>
    </ng-container>

    <ng-container matColumnDef="rfc">
      <th mat-header-cell *matHeaderCellDef>R.F.C.</th>
      <td mat-cell *matCellDef="let empleado">{{ empleado.rfc }}</td>
    </ng-container>

    <ng-container matColumnDef="area">
      <th mat-header-cell *matHeaderCellDef>Área</th>
      <td mat-cell *matCellDef="let empleado">{{ empleado.area || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="agrupador">
      <th mat-header-cell *matHeaderCellDef>{{ etiquetaAgrupar }}</th>
      <td mat-cell *matCellDef="let empleado">{{ empleado.grupo || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="horario">
      <th mat-header-cell *matHeaderCellDef>Horario</th>
      <td mat-cell *matCellDef="let empleado" [ngClass]="{'text-danger': empleado.horario == 'Sin horario'}">{{ empleado.horario  }}</td>
    </ng-container>

    <ng-container matColumnDef="alta">
      <th mat-header-cell *matHeaderCellDef>Alta</th>
      <td mat-cell *matCellDef="let empleado">{{ formatoFecha(empleado.alta) }}</td>
    </ng-container>

    <ng-container matColumnDef="baja">
      <th mat-header-cell *matHeaderCellDef>Baja</th>
      <td mat-cell *matCellDef="let empleado">{{ formatoFecha(empleado.baja) }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center" colspan="8">
        No hay empleados encontrados con los filtros seleccionados
      </td>
    </tr>
  </table>
</div>

<div [hidden]="cargando" class="d-flex justify-content-end m-3">
  <mat-paginator
    [length]="dataSource.data.length"
    (page)="paginator.pageIndex = $event.pageIndex"
    [pageSizeOptions]="[20, 40, 60, 100, dataSource.data.length]"
    [showFirstLastButtons]="dataSource.data.length > 20">
  </mat-paginator>
</div>

<div class="row px-5 py-2 col-12 text-white bg-primary" *ngIf="mensajeError">
  <span class="material-icons mr-2"> warning </span>
  <h5>
    <b>{{ mensajeError }}</b>
  </h5>
</div>

<div class="row px-5 py-2 col-12 text-white bg-success" *ngIf="mensajeRespuesta">
  <span class="material-icons mr-2"> done </span>
  <h5>
    <b>{{ mensajeRespuesta }}</b>
  </h5>
</div>
